<template>
  <v-layout>
    <div class="row pt-4 pb-4">
      <div class="col-12 mb-4">
        <h2>{{ customer.data.displayName }}</h2>
        <router-link
          :to="{ name: 'trip-booking.index' }"
          active-class="active"
          class="btn btn-primary btn-lg"
          tag="button"
        >
          {{ $t('Plan new trip') }}
        </router-link>
      </div>
      <div class="col-xs-6 col-md-3 order-xs-12 order-md-12">
        <div class="card mb-2">
          <div class="card-header"> {{ $t("General info") }} </div>
          <div class="card-body">
            <dl class="row">
              <dt class="col-sm-5">{{ $t('Customer number') }}:</dt>
              <dd class="col-sm-7">{{ customerMobilityCardNumber }}</dd>

              <dt class="col-sm-5">{{ $t('SSN') }}:</dt>
              <dd class="col-sm-7">{{ customer.data.customerNumber }}</dd>

              <dt class="col-sm-5">{{ $t('Gender') }}:</dt>
              <dd class="col-sm-7">{{ $t(`gender.${customer.data.personalInfo.gender}`) }} </dd>

              <dt class="col-sm-5">{{ $t('Date of birth') }}:</dt>
              <dd class="col-sm-7">{{ customerDob }} </dd>

              <dt class="col-sm-5">{{ $t('Payment type') }}:</dt>
              <dd class="col-sm-7">{{ $t(customerDefaultPaymentType) }} </dd>

              <dt class="col-sm-5">{{ $t('Indications') }}:</dt>
              <dd class="col-sm-7">{{ customerTransportObjectsDisplay }} </dd>
            </dl>
            <h6 class="card-subtitle mb-2 text-muted">{{ $t("Address") }}</h6>
            <ul class="list-unstyled">
              <li v-for="e in customerAddresses">
                <i class="fa fa-map-marker"></i> <a>{{ e.formattedAddress }}</a>
              </li>
            </ul>
            <h6 class="card-subtitle mb-2 text-muted">{{ $t("Contact") }}</h6>
            <span class="d-block"><i class="fa fa-envelope text-muted"></i> {{ customerEmail }}</span>
            <span class="d-block" v-if="customerPhoneNumber"><i class="fa fa-phone text-muted"></i> {{ customerPhoneNumber }}</span>

          </div>
        </div>
        <div class="card text-center text-white budget">
          <div class="card-header"> {{ $t('Personal budget') }}</div>
          <div class="card-body">
            <h6 class="card-subtitle mb-2 text-muted">{{ $t('Remaining budget')}}</h6>
            <h1 class="card-title">{{ customerBudgetRemainingDisplay }}</h1>
            <p class="card-text">{{ $t('Last update') }} {{ $moment().format('L') }}</p>
            <small class="text-muted">
              {{ $t('personalBudgetPerYear', ['1500 km']) }}
            </small>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-md-9 order-xs-1 order-md-1">
        <h2>{{ $t('My trips') }}
          <button class="btn btn-link"
                  @click="reloadTripsInTables"
          >{{ $t('Refresh') }}</button>
        </h2>
        <table class="table table-bordered table-striped table-sm"
               style="width:100%"
               ref="dtTripsActive"
        >
        </table>
        <hr />
        <h2>{{ $t('Trip history') }}</h2>
        <table class="table table-bordered table-striped table-sm"
               style="width:100%"
               ref="dtTripsEnded"
        >
        </table>
      </div>
    </div>
  </v-layout>
</template>

<script>
  /* ============
   * Home Index Page
   * ============
   *
   * The home index page.
   */

  import { mapGetters } from 'vuex';
  import VLayout from '@/layouts/Default.vue';
  import VCard from '@/components/Card.vue';
  import TripForm from '@/components/TripForm';
  import Address from '@/models/Address';

  export default {
    /**
     * The name of the page.
     */
    name: 'HomeIndex',

    /**
     * The components that the page can use.
     */
    components: {
      VLayout,
      VCard,
      TripForm
    },

    data() {
      return {

      }
    },

    computed: {
      ...mapGetters('account', [
        'customerEmail',
        'customerAddresses',
        'customerPaymentTypes',
        'customerDefaultPaymentType',
        'customerPhoneNumber',
        'customerDob',
        'customerSSN',
        'customerTransportObjectsDisplay',
        'customerBudgetRemaining',
        'customerBudgetRemainingDisplay',
        'customerMobilityCardNumber',
      ]),
      customer() {
        return this.$store.state.account;
      },
      customerPaymentTypesLocalized() {
        return this.customerPaymentTypes.map(e => this.$t(e)).join(", ")
      },
    },

    methods: {
      initTripTables() {
        const self= this;

        const columns= [
          {
            name: "tripDisplayCode.keyword",
            title: this.$t("Trip ID"),
            class: 'trip-list-td-trip-id',
            data: function(data) {
              return data.tripDisplayCode
            }
          },
          {
            name: "searchDatetime",
            title: self.$t("Date"),
            class: 'trip-list-td-datetime',
            data: function(data) {
              const date= _.get(data, 'data.events[0].eventTime.arrivalDatetime', data.dispatchDatetime || data.createdOnDatetime);
              if( date ) {
                return moment(date).format('L')
              }
              return ''
            }
          },
          {
            name: "searchDatetime",
            title: self.$t("Time"),
            data: function(data) {
              const date= _.get(data, 'data.events[0].eventTime.arrivalDatetime', data.dispatchDatetime || data.createdOnDatetime);
              if( date ) {
                return self.$moment(date).format('LT')
              }
              return ''
            }
          },
          // { stromlijn ne zeli ended time
          //   // name: "dispatchDatetime",
          //   title: self.$t("End time"),
          //   data: function(data) {
          //     const date= _.get(data, 'data.events[0].eventTime.arrivalDatetime', data.dispatchDatetime || data.createdOnDatetime);
          //     const seconds = _.get(data, 'data.routeDistance');
          //     if( date && seconds ) {
          //       return self.$moment(date).add(seconds, 'seconds').format('LT')
          //     }
          //     return ''
          //   }
          // },
          {
            name: "painless:data.events[0].eventLocation.streetName",
            title: self.$t("From"),
            data: function(data) {
              const addr= new Address(_.get(data.data, 'events[0].eventLocation'));
              return addr.formattedAddressHTML;
            }
          },
          {
            name: "painless:data.events[1].eventLocation.streetName",
            title: self.$t("To"),
            data: function(data) {
              const addr= new Address(_.get(data.data, 'events[1].eventLocation'));
              return addr.formattedAddressHTML;
            }
          },
          {
            name: "status.keyword",
            title: self.$t("Status"),
            data: function({status, eventPerforms}) {
              const icon= _.find(eventPerforms, e => e.performType.indexOf('NO_SHOW') > -1)
              return '<span style="white-space: nowrap">'+
                ( icon ? `<span title="${self.$t("No show")}" class="font-red-intense"><i class="fa fa-exclamation-triangle"></i></span> ` : '') + self.$t(`tripStatus.${status}`) +
                '</span>'
            }
          },
          {
            name: "data.tariff.customerFixAmountCents",
            title: self.$t("Contribution"),
            className: 'text-right mr-2 text-nowrap',
            data: function(data) {
              const price= _.get(data, 'data.tariff.customerFixAmountCents', 0) / 100;
              return accounting.formatMoney(price, '€ ', 2, '.', ',').trim()
            }
          },
          {
            name: "",
            title: "",
            data: function(data) {
              const date= _.get(data, 'data.events[0].eventTime.arrivalDatetime', data.dispatchDatetime || data.createdOnDatetime);
              const externalTripId= _.get(data, 'data.externalId');
              const editable= self.$moment().isBefore(moment(date).subtract(4, 'hours')) && externalTripId;

              const cancelTitle= editable ? self.$t('Cancel') :
                self.$t('Online cancellation available max 4 hours before pickup. Please contact the Drechthopper by phone')

              return `<div class="btn-group btn-group-justified" style="width:100%">
                        <a href="#/trip-booking/${data.data.externalId}" class="btn btn-sm btn-info ${editable ? '' : 'disabled'}">${self.$t('Edit')}</a>
                        <button type="button" class="btn btn-primary btn-sm" ${editable ? '' : 'disabled'} title="${cancelTitle}">${self.$t('Cancel')}</button>
                      </div>`
            },
            sortable: false
          }
        ];

        _.forEach([
          $(self.$refs.dtTripsActive),
          $(self.$refs.dtTripsEnded),
        ], ($table, index) =>{
            var xhrs= []
            var lastScrollPos= {};

            const customerDt= {};

          // const key= id.indexOf('active') > -1 ? 'active' : 'history'
          const activeTrips= index === 0 ? 'active'  : 'history';
          const key= activeTrips
          // const customerDt= self.customerDt[key]

          // customerDt.table = $('#'+id)

          const dt = $table.DataTable({
            // pagingType: 'simple',
            scrollX: true,
            scrollY: '450px',
            scrollCollapse: true,
            // processing: false,
            serverSide: true,
            // select: { info: false, style: 'single' },
            // scroller: true,
            pageLength: 25,
            lengthMenu: [ 25, 50, 75, 100, 150 ],
            // dom: "<'row'<'col-sm-6 top-left'l><'col-sm-6 dt-fix-children'<'pull-right'p><'pull-right'i>>>" +
            dom:    "<'row'<'col-sm-12 sorting-display'>>" +
              "<'row mb-2'<'col-sm-12'tr>>" +
              "<'row'<'col-sm-6'l><'col-sm-6'<'pull-right'p><'pull-right mr-2'i>>>",
            ajax: function (data, callback, settings) {
              // will save scroll pos if it's same customer as in last req
              //lastScrollPos.restore= customerDt.storedFilters.filters.customerUid === self.customer.customerUid

              customerDt.storedFilters= {
                size: data.length,
                from: data.start,
                filters: {
                  not_status: index === 0 ? ['ENDED', 'CANCELED'] : null,
                  status: index !== 0 ? ['ENDED', 'CANCELED'] : null,
                  datetimeFrom: index === 0 ? moment().toISOString() : null,
                  eventPerformType: index !== 0 ? ['PICKUP_EVENT_NO_SHOW','DROPOFF_EVENT_UNBOARDED'] : null,
                  customerUid: self.customer.customerUid || "NON-EXISTING",
                  not_tripType: ["COMBINATION_TRIP"],
                  order: _.transform(data.order, (arr, c) =>{
                    var column= data.columns[c.column].name
                    arr.push({
                      column,
                      dir: c.dir
                    })
                  }, [])
                },
                searchTerm: data.search.value,
                _source: {
                  excludes:[
                    "*.routePolyline",
                    "data.priceCalculatorResult"
                  ]
                }
              }

              var newXHR= $.ajax({type: 'post',
                url: process.env.VUE_APP_API_LOCATION + '/trips/search',
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify(customerDt.storedFilters),
                headers: {
                  Authorization: `Bearer ${localStorage.getItem('id_token')}`
                }
              })
                .done(function(res) {
                  // rootTab.find('ul.nav-tabs').first('li').find('.badge').html(trips.recordsTotal);
                  // $('a[href="#'+rootTab.attr('id')+'"]').find('.badge').html(trips.recordsTotal);
                  for(var i=0; i<res.hits.length; i++) {
                    res.hits[i]= res.hits[i]._source
                  }

                  callback({
                    data: res.hits.map(e =>{
                      e._pickupMoment= moment(e.pickupTimeSearchDatetime);
                      return e;
                    }),
                    recordsTotal: res.total,
                    recordsFiltered: res.hits.length < res.total ? res.total : res.hits.length,
                    draw: data.draw++
                  });

                })
                .fail(function (jqXHR, textStatus, errorThrown) {
                  // console.log(jqXHR, textStatus, errorThrown);
                  toastr.error(self.$t("Failed to fetch trips from server"), errorThrown);

                })
                .always(function(){
                });
              xhrs.push(newXHR);
            },
            preDrawCallback: function (settings) {
              lastScrollPos.top= $(settings.nScrollBody).scrollTop();
              lastScrollPos.left = $(settings.nScrollBody).scrollLeft();
              // get selected row
              try {
                var selected = dt.row('.selected').data();
                if (selected) {
                  lastScrollPos.lastSelectedTripUid= selected.tripUid;
                }
              } catch (e) {
                // first time dt is not defined
                // ignore error TypeError
              }
            },
            drawCallback: function (settings) {
              //restore scroll position when draw is finished
              if( lastScrollPos && lastScrollPos.restore ) {
                $(settings.nScrollBody).scrollTop(lastScrollPos.top||0);
                $(settings.nScrollBody).scrollLeft(lastScrollPos.left||0);
                if( lastScrollPos.lastSelectedTripUid ) {
                  const row= dt.row('.' + lastScrollPos.lastSelectedTripUid)
                  if( row ) {
                    dt.row(row).select()
                  }
                }
              } else {
                lastScrollPos= {}
              }
            },
            colReorder: false,
            order: [[2, key==='active' ? 'asc' : 'desc']],
            columns: key==='active' ? columns.slice() : columns.slice(0,-1),
            language: {
              url: self.$root.locale === 'en' ? 'https://cdn.datatables.net/plug-ins/1.11.3/i18n/en-gb.json'
                : 'https://cdn.datatables.net/plug-ins/1.11.3/i18n/'+self.$root.locale+'_'+self.$root.locale+'.json'
            }
          })
            .on( 'preXhr.dt', function ( e, settings, data ) {

            })
            .on( 'xhr.dt', function ( e, settings, data, json ) {

            })
            .on( 'draw', function () {

            })
        })

        $(self.$refs.dtTripsActive).on('click', 'button', function(e){
            const data = $(self.$refs.dtTripsActive).DataTable().row( $(this).parents('tr') ).data();
            const {externalId}= data.data;
            if(!externalId) {
              self.$swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Trip'
              })
              return;
            }
            self.$swal.fire({
              title: self.$t("Are you sure?"),
              text: self.$t("You won't be able to revert this!"),
              icon: 'warning',
              confirmButtonText: self.$t('Cancel trip'),
              cancelButtonText: self.$t('Close'),
              showCancelButton: true,
              showLoaderOnConfirm: true,
              preConfirm: (login) => {
                return $.ajax({
                  type: 'delete',
                  url: process.env.VUE_APP_API_LOCATION + '/trips/' + externalId,
                  headers: {
                    Authorization: `Bearer ${localStorage.getItem('id_token')}`
                  }
                }).done(()=>{
                  self.$swal.fire({
                    icon: 'success',
                    title: self.$t('Trip canceled'),
                    showConfirmButton: false,
                    timer: 1200
                  }).then(()=>{
                    self.reloadTripsInTables();
                    // za svaki slucaj da se tripovi refreshaju
                    setTimeout(self.reloadTripsInTables, 1500);
                    setTimeout(self.reloadTripsInTables, 6000);
                  })
                })
                  .catch(error => {
                    self.$swal.showValidationMessage(
                      `Request failed: ${error}`
                    )
                  })
              },
              allowOutsideClick: () => !self.$swal.isLoading()
          })
        });

      },
      reloadTripsInTables() {
        _.forEach([
          $(this.$refs.dtTripsActive),
          $(this.$refs.dtTripsEnded),
        ], $table =>{
          $table.DataTable().ajax.reload();
        })
      },
    },

    mounted() {
      if( process.env.NODE_ENV !== 'production' ) {
        // expose evil for dev purpose only!
        window._Home= this;
      }
      this.initTripTables();
    },

    watch: {
      'customer.customerUid'() {
        this.reloadTripsInTables()
      }
    }

  };
</script>

<style scoped>
  .fa-map-marker {
    opacity: .6;
  }
  .budget {
    background-color: #43bcef;
  }
  .budget .text-muted {
    color: #b6e9ff !important;
  }
</style>
